module.exports = __webpack_public_path__ + "img/pochta1class.190485d9.jpg";